import axios from "axios";
import { hostname } from "src/HostName";

const systemConfigInstance = axios.create({
  baseURL: hostname,
  headers: {
    "Content-Type": "application/json",
  },
});
// ------------------Cache Session-----------------------------------
export const getCacheSessDataApi = () =>
  systemConfigInstance.get("get_traveloes_cache");
export const updateCacheSessDataApi = (data) =>
  systemConfigInstance.patch("update/session/cache", data);
// ------------------Payment Method-----------------------------------
export const getPayMethodDataApi = () =>
  systemConfigInstance.get("get/paymentmethod");

export const addPayMethodDataApi = (data) =>
  systemConfigInstance.post("add/paymentmethod", data);
export const updatePayMethodDataApi = (data) =>
  systemConfigInstance.patch("update/payment/method", data);
export const deletePayMethodDataApi = (id) =>
  systemConfigInstance.delete("delete/paymentmethod/" + id);

export const getMetaListApi = () => systemConfigInstance.get("b2b/meta/list");
// ------------------Location-----------------------------------
export const getLocationDataApi = () =>
  systemConfigInstance.get("get/location");

export const updateLocationDataApi = (data) =>
  systemConfigInstance.patch("update/location", data);

// ------------------Sync Config-----------------------------------
export const getSyncConfigDataApi = () =>
  systemConfigInstance.get("get/sysconfig");
export const updateSyncConfigDataApi = (data) =>
  systemConfigInstance.patch("update/sysconfig", data);
